




















































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'


@Component

export default class ComponentAlvoradaPrevisaoUsoQuimioterapico extends Vue {
  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get getErrorMessage() {
    return this.getSolicitacaoStore.errorMessage
  }

  messageTextArea() {
    if (this.getSolicitacaoStore.solicitacao.medEspeciaisTemp === '2') {
      this.getSolicitacaoStore.clearPrevisaoUsoQuimioterapico()
    }
  }
}
